"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = require("classnames");
var React = require("react");
var lang_1 = require("../../../utils/lang");
var Image_1 = require("../../common/Image");
var styles = require("./index.scss");
var store_1 = require("./store");
var utils_1 = require("./utils");
var getLang = lang_1.getEzbuyLang();
var VoucherOne = (function (_super) {
    __extends(VoucherOne, _super);
    function VoucherOne() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VoucherOne.prototype.render = function () {
        var _a;
        var _b = this.props, voucher = _b.voucher, bgColor = _b.bgColor, ui = _b.ui, onClaim = _b.onClaim;
        var isExhaust = voucher.voucherState === store_1.VoucherState.RanOut;
        var isExpired = voucher.voucherState === store_1.VoucherState.Expired;
        var isClaimed = voucher.voucherState === store_1.VoucherState.Received;
        return (React.createElement("div", { className: classnames_1.default(styles.voucherCard, styles.voucherOne, (_a = {},
                _a[styles.exhaust] = isExhaust,
                _a[styles.expired] = isExpired,
                _a)) },
            React.createElement("img", { src: getLang("REDEEMEDSTAMP"), className: styles.stamp, style: { display: isClaimed ? "block" : "none" }, alt: "" }),
            React.createElement(Image_1.default, { key: voucher.info.img, src: voucher.info.img, className: styles.voucherImg, params: "imageView2/2/w/700", aliSize: 7 }),
            React.createElement("div", { className: styles.controllerArea, style: { backgroundColor: ui.bgColor, color: ui.colorTable && ui.colorTable.textColor } },
                React.createElement("a", { onClick: function () { return onClaim(voucher); } }, utils_1.getVoucherText(voucher.voucherState, !!voucher.info.link))),
            React.createElement("i", { className: styles.dotLeft, style: { backgroundColor: bgColor } }),
            React.createElement("i", { className: styles.dotRight, style: { backgroundColor: bgColor } })));
    };
    return VoucherOne;
}(React.PureComponent));
exports.default = VoucherOne;
